import Time from '../Components/time';
import FetchHumidity from '../Components/fetchHumidity';
import FetchTemperature from '../Components/fetchTemperature';
import Date from "../Components/date"; 
import 'bootstrap/dist/css/bootstrap.min.css'
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

function Home() {
  return (
      <div className="App">
      <header className="App-header">
  
      <Container>
        <Row>
            <Row>
              <Col>
                <h1>
                  <Date />
                    <Time />
                </h1>
              </Col>
            </Row>
          <Col> <FetchTemperature/></Col>
          <Col> <FetchHumidity/> </Col>
        </Row>
      </Container>
      </header>
    </div>
  );
}
export default Home;
